import { SigninForm } from 'features/auth/components/signin-form';
import darklogo from 'assets/images/bebrave-logo.svg';
import lightlogo from 'assets/images/bebrave-logo.svg';
import { useTheme } from 'components/core/theme-provider';
import { useGetLoginOptions } from 'features/auth/hooks/use-auth';
import { LoadingOverlay } from 'components/core/loading-overlay';
import { useCommonStore } from "state/store/common/useCommonStore";

export function SigninPage() {
  const { theme } = useTheme();
  const { data: loginOption, isLoading } = useGetLoginOptions();
  const setUser = useCommonStore((state) => state.setUser);
  
  setUser(null);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="w-14 h-14 mb-2">
        <img src={theme == 'dark' ? darklogo : lightlogo} className="w-full h-full" alt="logo" />
      </div>
      <div>
        <div className="text-2xl font-bold text-high-emphasis">Log in</div>
        {/*<div className="flex items-center gap-1 mt-1">*/}
        {/*  <span className="text-sm font-normal text-medium-emphasis">Don’t have an account?</span>*/}
        {/*  <Link*/}
        {/*    to={'/signup'}*/}
        {/*    className="text-sm font-bold text-primary hover:text-primary-600 hover:underline"*/}
        {/*  >*/}
        {/*    {t('SIGN_UP')}*/}
        {/*  </Link>*/}
        {/*</div>*/}
      </div>
      <div className="w-full invisible h-0">
        <div className="rounded-lg bg-success-background border border-success p-4">
          <p className="text-xs font-normal text-success-high-emphasis">
            <span className="font-semibold">demo.construct@seliseblocks.com</span> with password:{' '}
            <span className="font-semibold">H%FE*FYi5oTQ!VyT6TkEy</span>
          </p>
        </div>
      </div>

      {loginOption && (
        <SigninForm
          loginOption={{
            ...loginOption,
          }}
        />
      )}
    </div>
  );
}
